module.exports = __webpack_public_path__ + "media/images/pages/fcr-flow/stage-3-f43382f6fffcd412b1b31b7e13ea00eb.png";